// Decides where "/" should go.
//
// An owner lands on the dashboard, a cashier on the POS, an accountant on
// reports - whichever is the first screen their permissions actually allow.
// Somebody signed out goes to the login page.

import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { landingPathFor } from './navigation';
import { Spinner } from '../components/common/Spinner';

export function LandingRedirect() {
  const status = useAuthStore((state) => state.status);
  const permissions = useAuthStore((state) => state.permissions);

  if (status === 'checking') {
    return (
      <div className="flex h-screen items-center justify-center bg-surface-page text-butcher-green">
        <Spinner size="lg" label="Loading" />
      </div>
    );
  }

  if (status !== 'authenticated') {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={landingPathFor(permissions)} replace />;
}
